<template>
    <a class="nav-link" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')" :class="{'wish-global': !wishListCount, 'wish-global active': wishListCount}">
        <span class="badge-right mr-1 d-none d-sm-inline">{{ wishListCount }}</span>
        <span class="icon-document" aria-hidden="true"></span>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
